/**
 * Shared tax year configuration - uniform across the application.
 * Years from BASE_YEAR through current year + YEARS_AHEAD (10 years out).
 */

export const BASE_YEAR = 2020;
export const YEARS_AHEAD = 10;

/**
 * Get array of valid tax years, newest first.
 * Range: BASE_YEAR (2020) through current year + 10.
 */
export function getTaxYearOptions() {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + YEARS_AHEAD;
  const years = [];
  for (let y = endYear; y >= BASE_YEAR; y--) {
    years.push(y);
  }
  return years;
}

/**
 * Check if a year is within valid range.
 */
export function isValidTaxYear(year) {
  const num = parseInt(year, 10);
  if (isNaN(num)) return false;
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + YEARS_AHEAD;
  return num >= BASE_YEAR && num <= endYear;
}
